/** EVENTS.JS For the events page **/

/* Initialize */
var eventElements = document.querySelectorAll('.calendar .event');
var infoLinks = document.querySelectorAll('.topic_link:not(.primary)');

/* Listeners */
eventElements.forEach((eventEl)=>{
    eventEl.addEventListener('click', (e)=>{
        var event_info = eventEl.nextElementSibling;
        $(event_info).slideToggle('medium');
        if($(eventEl).find('i').attr('class') == 'arrow-up'){
            $(eventEl).find('i').addClass('arrow-down').removeClass('arrow-up');
        }else{
            $(eventEl).find('i').addClass('arrow-up').removeClass('arrow-down');
        }
    })
})

infoLinks.forEach((link)=>{
    link.addEventListener('click', (e)=>{
        var linkVal = link.getAttribute('data-value');
        $('.more_info').hide();
        $('.more_info_' + linkVal).slideDown('fast');
    })
})

if(location.hash == "#flea"){
  setTimeout(function() {
    $('html, body').animate({ scrollTop: $('#events-section-flea-esta').offset().top - $('#header').outerHeight() }, 500);
  }, 1000);
}
